var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n2-center-container",staticStyle:{"background-color":"#fff","padding":"10px"}},[_c('app-content',{attrs:{"name":"web.term.reservation"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }